import { RecordsPriorityIntegration } from './RecordsPriorityIntegration';

export { RecordsPriorityIntegration };
